import { FlexBox } from '@ardoq/layout';
import { colors, r8 } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';
export const ISLAND_DEFAULT_MAX_WIDTH = '1440px';
const ISLAND_DEFAULT_MIN_WIDTH = '700px';

export const IslandContainer = styled(FlexBox).attrs({
  flexDirection: 'column',
  gap: 'none',
})<{
  $isSelected?: boolean;
  $isSelectable?: boolean;
  $maxWidth?: React.CSSProperties['maxWidth'];
  $minWidth?: React.CSSProperties['minWidth'];
  $minHeight?: React.CSSProperties['minHeight'];
  $preventScroll?: boolean;
  $withBorder?: boolean;
  $fullHeight?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}>`
  border-radius: ${r8};
  background-color: ${colors.surfaceDefault};
  min-width: ${({ $minWidth = ISLAND_DEFAULT_MIN_WIDTH }) => $minWidth};
  max-width: ${({ $maxWidth = ISLAND_DEFAULT_MAX_WIDTH }) => $maxWidth};
  ${({ $withBorder = true }) =>
    $withBorder &&
    css`
      border: 1px solid ${colors.borderAction};
    `};
  ${({ $minHeight }) =>
    $minHeight &&
    css`
      min-height: ${$minHeight};
    `};
  ${({ $isSelectable }) =>
    $isSelectable &&
    css`
      &:hover {
        outline: 1px solid ${colors.borderActionHover};
        cursor: pointer;
      }
    `}
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      outline: 1px solid ${colors.borderActionActive};
    `}
  ${({ $preventScroll }) =>
    $preventScroll &&
    css`
      overflow-y: hidden;
    `}
  ${({ $fullHeight }) =>
    $fullHeight &&
    css`
      height: 100%;
    `}
`;

export const ISLAND_SELECTOR = IslandContainer.toString();
